"use client";

import useTranslate from "@app/_hooks/useTranslate";

export default function ProductCardVariants({ count }: { count: number }) {
  const t = useTranslate();

  if (count <= 1) {
    return null;
  }

  return (
    <span className="text-sm">
      {t("moreVariants")} ({count})
    </span>
  );
}

ProductCardVariants.displayName = "ProductCardVariants";
